import { ArrowUpRight, BookOpen, CalendarCheck, Send } from "lucide-react";
import { BTN_PRIMARY, BTN_SECONDARY } from "@/lib/academy/ui";

const ACTIONS = {
  foundations: [["lesson", "Try the Free Lesson", BookOpen], ["inquiry", "Request Founding Cohort Pricing", Send, { offer: "founding-cohort", audience: "individual" }]],
  business: [["inquiry", "Discuss a Company Pilot", Send, { offer: "company-pilot", audience: "company" }], ["calendly", "Discuss Team Training", CalendarCheck]],
  "first-opportunity": [["careers", "Explore the Careers Hub", ArrowUpRight], ["inquiry", "Discuss This Program", Send, { offer: "program-interest" }]],
};

const DEFAULT_ACTIONS = [["inquiry", "Discuss This Program", Send, { offer: "program-interest" }]];

export const ProgramActions = ({ program, onAction }) => (
  <div data-testid="academy-program-detail-actions" className="flex flex-col gap-3">
    {(ACTIONS[program.id] || DEFAULT_ACTIONS).map(([kind, label, Icon, preset], index) => (
      <button key={label} type="button" data-testid={`academy-program-action-${kind}`} onClick={() => onAction(kind, { ...preset, program: program.id })} className={index === 0 ? BTN_PRIMARY : BTN_SECONDARY}>
        <Icon size={14} aria-hidden="true" />{label}
      </button>
    ))}
  </div>
);
